<template>
  <div>
    <div class="main">
      <div class="header">
        <ul>
          <li>
            <a href="javascript:;" @click="category(1)" :class="{ choose: isChoose == 1 }">
              未提出 (
              <strong>{{ tabData.orderTemporary }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(7)" :class="{ choose: isChoose == 7 }">
              全部 (
              <strong>{{ tabData.orderAll }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(0)" :class="{ choose: isChoose == 0 }">
              注文書 (
              <strong>{{ tabData.all }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(2)" :class="{ choose: isChoose == 2 }">
              見積中 (
              <strong>{{ tabData.orderConfirm }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(3)" :class="{ choose: isChoose == 3 }">
              支払い待ち (
              <strong>{{ tabData.orderPay }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(4)" :class="{ choose: isChoose == 4 }">
              買い付け中 (
              <strong>{{ tabData.orderPurchase }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(5)" :class="{ choose: isChoose == 5 }">
              買い付け完了 (
              <strong>{{ tabData.orderPurchased }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:;" @click="category(8)" :class="{ choose: isChoose == 8 }">
              発送済み (
              <strong>{{ tabData.orderDelivery }}</strong>
              )
            </a>
          </li>
        </ul>
        <!-- <a href="javascript:;" class="fr history" @click="historyOrder"
          >過去の注文書</a
        > -->
      </div>
      <div id="search">
        <div class="date fl">
          日付
          <el-date-picker v-model="list.dateStart" type="date" placeholder="日付を選択" size="small"
            value-format="yyyy-MM-dd"></el-date-picker>
          --
          <el-date-picker v-model="list.dateEnd" type="date" placeholder="日付を選択" size="small"
            value-format="yyyy-MM-dd"></el-date-picker>
          <a href="javascript:;" @click="search">確定</a>
        </div>
        <div class="search fr">
          <input type="text" v-model="list.ordno" placeholder="注文書番号、注文管理番号、受取人" @keyup.enter="search" />
          <a href="javascript:;" @click="search">確定</a>
        </div>
      </div>
      <div class="body" v-for="(item, index) in lists" :key="item.id">
        <ol>
          <li class="border">商品詳細</li>
          <li class="flex05 border">日付</li>
          <li class="flex05">配送先</li>
        </ol>
        <div class="order">
          <div class="flex15">
            注文番号：<router-link :to="'/zhuwen?ordno=' + item.ordno" target="_blank">{{ item.ordno }}</router-link>
            <el-tooltip placement="top" v-if="item.autoPordno">
              <div slot="content">
                ※倉庫止めにされる場合はクリックして変更可能。
              </div>
              <button style="margin: 0 30px" @click="amendPei(item)">
                直送
              </button>
            </el-tooltip>
            <el-tooltip placement="top" v-else-if="item.pordnoInfo == false">
              <div slot="content">
                ※国際発送する際は倉庫より配送依頼提出してください。
              </div>
              <button style="margin: 0 30px">倉庫止め</button>
            </el-tooltip>
            <span style="margin: 0 70px" v-else></span>

            <input type="text" placeholder="備考欄「お客様用、担当者は見えません」" v-model="item.client_remark" />
            <button @click="updateClientRemark(item)" class="fr">保存</button>
            <div class="guanli">
              お客様注文管理番号:
              <span v-if="item.show">{{ item.manage_ordno }}</span>
              <input type="text" v-model="item.manage_ordno" v-else />

              <button class="fr" v-if="item.show" @click="redact(index)">
                編集
              </button>
              <button class="fr" v-else @click="updateManageOrdno(item, index)">
                保存
              </button>
              <span class="fr" style="width: 100px;">
                {{ item.shopify_name }}
              </span>

            </div>
          </div>
          <div class="flex05">
            <button @click="siteAlter(item)" v-if="item.canUpdateAddress">
              編集
            </button>
          </div>
        </div>

        <div class="details">
          <div class="ul">
            <ul v-for="(goodsItem, goodsIndex) in item.goods" :key="goodsItem.id">
              <li class="border content" style="padding-right: 0px">
                <div class="img fl">
                  <img :src="goodsItem.pic" alt="" />
                </div>
                <div class="text fl">
                  <p>
                    注文書番号:{{ goodsItem.ordno }}-{{ goodsIndex + 1 }}
                    <span class="fr">{{ goodsItem.statusName }}</span>
                  </p>
                  <div class="url">
                    <router-link :to="goodsItem.type == 'rakumart'
                      ? '/details?id=' + goodsItem.iid
                      : `/details1688?iid=${goodsItem.iid}&type=${goodsItem.type}${goodsItem.mi_id ? '&mi_id=' + goodsItem.mi_id : ''}`
                      " target="_blank">
                      www.rakumart-2c.com/#{{
                        goodsItem.type == "rakumart"
                          ? "/details?id=" + goodsItem.iid
                          : `/details1688?iid=${goodsItem.iid}&type=${goodsItem.type}${goodsItem.mi_id ? '&mi_id=' + goodsItem.mi_id : ''}`
                      }}
                    </router-link>
                  </div>
                  <div class="color row">
                    <div class="shuXing">
                      <span>カラー</span>
                      <input type="text" v-model="goodsItem.color" disabled />
                    </div>
                    <div class="item">
                      <span>数量：</span>{{ goodsItem.num
                      }}<span style="margin-left: 20px">在庫：</span>{{ goodsItem.zaiko }}
                    </div>
                  </div>
                  <div class="size row">
                    <div class="shuXing">
                      <span>サイズ</span>

                      <input type="text" v-model="goodsItem.psize" disabled />
                    </div>
                    <div class="item">
                      <span>単価：</span>{{ goodsItem.price }}
                    </div>
                  </div>
                  <div class="bei row">
                    <span>備考</span>
                    <input type="text" v-model="goodsItem.bei" disabled />

                    <!-- <button @click="updateRemark(goodsItem.id,index,goodsIndex)">修改</button> -->
                  </div>
                  <div class="huan" v-if="goodsItem.is_append_urgent">換</div>
                </div>
              </li>
              <li class="time flex05 border">
                <p class="timeItem">
                  <span>見積もり日</span> {{ goodsItem.datetimeBaojia }}
                </p>
                <p class="timeItem">
                  <span>店舗発送日</span> {{ goodsItem.datetimeCaigou }}
                </p>
                <p class="timeItem">
                  <span>検品完了日</span> {{ goodsItem.datetimeDaoda }}
                </p>
                <p class="timeItem">
                  <span>発送日（日本）</span> {{ goodsItem.datetimeFahuo }}
                </p>
              </li>
            </ul>
          </div>

          <div class="sizhi">
            <div>
              <p v-for="(siteItem, siteIndex) in item.site" :key="siteIndex">
                <span>{{ siteItem.name }}{{ siteItem.data }}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- 配送单 -->
        <div class="deliver" v-if="item.pordnoInfo != false">
          <div class="deliverOrder" v-for="pordnoItem in item.pordnoInfo" :key="pordnoItem.pordno">
            <div class="danhao">
              <span> 配送番号　</span>
              <router-link :to="'/deliver?pordno=' + pordnoItem.pordno" target="_blank">
                {{ pordnoItem.pordno }}
                <span v-if="pordnoItem.realname">-{{ pordnoItem.realname }}</span>
              </router-link>
            </div>
            <div class="weight">
              <span>重量{{ pordnoItem.freight }}KG</span>
              <span>国際送料{{ pordnoItem.kin }}円</span>
            </div>
            <div class="gujiOrder">
              <div v-for="pnoItem in pordnoItem.pnos" :key="pnoItem.pno">
                <span>国際追跡</span>
                <a :href="'https://webcsw.ocs.co.jp/csw/ECSWG0201R00003P.do?cwbno=' +
                  pnoItem.pno
                  " target="_blank" v-if="pnoItem.wuliu == 'OCS'">
                  {{ pnoItem.pno }}</a>
                <a :href="'https://trackings.post.japanpost.jp/services/srv/search/direct?reqCodeNo1=' +
                  pnoItem.pno +
                  '&searchKind=S002&locale=ja'
                  " target="_blank" v-else-if="pnoItem.wuliu == 'EMS' || pnoItem.wuliu == '塔普旺EMS'">
                  {{ pnoItem.pno }}</a>
                <form name="toi" method="POST" id="searchNumAside" class="pc-form"
                  action="https://toi.kuronekoyamato.co.jp/cgi-bin/tneko" target="toiawase" v-else>
                  <span>
                    <input type="hidden" name="number01" class="number01" :value="pnoItem.pno" />

                    <input id="ytc_pc_003" type="submit" class="submit getExpress" :value="pnoItem.pno" />
                  </span>
                </form>

                <span> {{ pnoItem.status }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fenye">
        <div class="fenye">
          <el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page="list.page" :page-size="list.pageSize" :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
      <!-- 修改地址弹框 -->
      <el-dialog title="住所变更" :visible.sync="siteDialogVisible" width="50%" center>
        <div class="site">
          <!-- 輸入者(Importer) -->
          <div class="importer fl margin-right">
            <h4>輸入者(Importer)</h4>
            <el-select v-model="address1.remark" placeholder="配送先管理から選択" @change="selectSite($event, 1)" size="mini">
              <el-option v-for="item in aid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
            </el-select>

            <div class="importer-box">
              <ul>
                <li>
                  会社：
                  <input type="text" v-model="address1.company" />
                </li>
                <li>
                  氏名：
                  <input type="text" v-model="address1.realname" @blur="verifySiteNull(address1.realname, 0)" />
                </li>
                <li>
                  郵便：
                  <input type="text" v-model="address1.zip" @blur="verifySiteNull(address1.zip, 1)" />
                </li>
                <li>
                  住所：
                  <input type="text" v-model="address1.address" @blur="verifySiteNull(address1.address, 2)" />
                </li>
                <li>
                  携帯番号：
                  <input type="text" v-model="address1.mobile" @blur="verifySiteNull(address1.mobile, 3)" />
                </li>
              </ul>
            </div>
          </div>
          <!-- 配送先 -->
          <div class="importer fl">
            <h4>配送先</h4>
            <el-select v-model="address2.remark" placeholder="配送先管理から選択" @change="selectSite($event, 2)" size="mini">
              <el-option v-for="item in hid" :key="item.aid" :label="item.remark" :value="item.aid"></el-option>
            </el-select>

            <div class="importer-box">
              <ul>
                <li>
                  会社：
                  <input type="text" v-model="address2.company" />
                </li>
                <li>
                  氏名：
                  <input type="text" v-model="address2.realname" @blur="verifySiteNull(address2.realname, 0)" />
                </li>
                <li>
                  郵便：
                  <input type="text" v-model="address2.zip" @blur="verifySiteNull(address2.zip, 1)" />
                </li>
                <li>
                  住所：
                  <input type="text" v-model="address2.address" @blur="verifySiteNull(address2.address, 2)" />
                </li>
                <li>
                  携帯番号：
                  <input type="text" v-model="address2.mobile" @blur="verifySiteNull(address2.mobile, 3)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button @click="siteDialogVisible = false">キャンセル</button>
          <button style="margin-left: 20px" @click="verifySite">保存</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  clientOrderList,
  clientOrderListTab,
  updateRemark,
  updateClientRemark,
  updateOrderAddress,
  forbid_pordno,
  updateManageOrdno,
} from "../../../api/API/productState";
import { getAddress, addAddress1 } from "../../../api/API/site";
export default {
  data() {
    return {
      siteDialogVisible: false,
      aid: [],
      hid: [],
      address1: {
        address: "",
        addressroma: "",
        aid: "",
        company: "",
        def1: 0,
        def2: 0,
        mobile: "",
        nameroma: "",
        realname: "",
        remark: "",
        status: 0,
        tel: "",
        user_id: "",
        zip: "",
      },
      address2: {
        address: "",
        addressroma: "",
        aid: "",
        company: "",
        def1: 0,
        def2: 0,
        mobile: "",
        nameroma: "",
        realname: "",
        remark: "",
        status: 0,
        tel: "",
        user_id: "",
        zip: "",
      },
      site: {
        aid: "",
        hid: "",
        ordno: "",
      },
      siteOrder: "",
      isChoose: 7,
      token: localStorage.getItem("token"),
      lists: [],
      tabData: [],
      list: {
        page: 1,
        pageSize: 50,
        state: 7,
        ordno: "",
        dateStart: "",
        dateEnd: "",
      },
      total: 0,
    };
  },
  created() {
    this.clientOrderList();
    clientOrderListTab().then((res) => {
      this.tabData = res.data;
    });
    this.getAddress();
  },
  methods: {
    // 切换状态
    category(index) {
      this.isChoose = index;
      this.list.state = index;
      this.list.page = 1;
      this.clientOrderList();
    },
    search() {
      this.list.page = 1;
      //   this.list.state = 7;
      //   this.isChoose = 7;
      this.clientOrderList();
    },
    //获取订单列表
    clientOrderList() {
      clientOrderList(this.list).then((res) => {
        console.log(res);
        this.lists = res.data.data;
        this.total = res.data.total;
        this.lists.forEach((item) => {
          item.show = true;
        });
        this.extractionData();
      });
    },
    // 提取时间和地址
    extractionData() {
      this.lists.forEach((item) => {
        item.site = [];
        item.time = [];
        for (let key in item.address_receive) {
          if (key == "company") {
            item.site.push({
              name: "会社：",
              data: item.address_receive[key],
            });
          } else if (key == "realname") {
            item.site.push({
              name: "氏名：",
              data: item.address_receive[key],
            });
          } else if (key == "zip") {
            item.site.push({
              name: "郵便：",
              data: item.address_receive[key],
            });
          } else if (key == "address") {
            item.site.push({
              name: "住所：",
              data: item.address_receive[key],
            });
          } else if (key == "mobile") {
            item.site.push({
              name: "携帯番号：",
              data: item.address_receive[key],
            });
          }
        }
        for (let key in item.uoduo_nagare) {
          if (key == "company") {
            item.site.push({
              name: "会社：",
              data: item.address_receive[key],
            });
          } else if (key == "realname") {
            item.site.push({
              name: "氏名：",
              data: item.address_receive[key],
            });
          } else if (key == "zip") {
            item.site.push({
              name: "郵便：",
              data: item.address_receive[key],
            });
          } else if (key == "address") {
            item.site.push({
              name: "住所：",
              data: item.address_receive[key],
            });
          } else if (key == "mobile") {
            item.site.push({
              name: "携帯番号：",
              data: item.address_receive[key],
            });
          }
        }
      });
    },
    historyOrder() {
      this.list.state = 6;
      this.clientOrderList();
    },
    // 选择数量
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.clientOrderList();
    },
    // 选择页
    handleCurrentChange(val) {
      this.list.page = val;
      this.clientOrderList();
    },
    // 编辑管理番号
    redact(i) {
      this.lists[i].show = false;
      this.$forceUpdate();
    },
    updateManageOrdno(item, i) {
      let list = {
        ordno: item.ordno,
        manage_ordno: item.manage_ordno,
      };
      updateManageOrdno(list).then((res) => {
        if (res.success) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.lists[i].show = true;
        this.$forceUpdate();
      });
    },
    // 自用备注修改
    updateClientRemark(item) {
      let list = {
        ordno: item.ordno,
        client_remark: item.client_remark,
      };
      updateClientRemark(list).then((res) => {
        this.$message.success("保存成功");
      });
    },
    // 修改备注
    updateRemark(id, i, index) {
      let list = {
        id: id,
        remark: this.lists[i][index].bei,
      };
    },
    // 地址修改弹框
    siteAlter(item) {
      if (item.address_receive != null) {
        this.address2 = item.address_receive;
      }
      if (this.input_info != null) {
        this.address1 = item.input_info;
      }
      //   console.log(this.address2);
      this.site.ordno = item.ordno;

      this.siteDialogVisible = true;
    },
    // 获取地址
    getAddress() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "getAddress",
        token: this.token,
      };
      getAddress(list).then((res) => {
        if (res.code != 1) return;
        this.aid = res.data.delivery;
        this.hid = res.data.outlet;
      });
    },
    // 选择地址
    selectSite(e, i) {
      if (i == 1) {
        this.aaid = e;
        this.aid.forEach((item) => {
          if (item.aid == e) {
            this.address1 = item;
          }
        });
      } else if (i == 2) {
        this.hhid = e;
        this.hid.forEach((item) => {
          if (item.aid == e) {
            this.address2 = item;
          }
        });
      }
    },
    // 验证地址
    verifySite() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "addAddress1",
        token: this.token,
        company: this.address1.company,
        realname: this.address1.realname,
        zip: this.address1.zip,
        address: this.address1.address,
        mobile: this.address1.mobile,
        def1: 1,
        def2: 0,
        status: 0,
      };
      addAddress1(list).then((res) => {
        if (res.code != 1)
          return this.$message.error("輸入者をご記入ください。");
        this.site.aid = res.data.aid;
        list.company = this.address2.company;
        list.realname = this.address2.realname;
        list.zip = this.address2.zip;
        list.address = this.address2.address;
        list.mobile = this.address2.mobile;
        addAddress1(list).then((res) => {
          if (res.code != 1)
            return this.$message.error("配送先をご記入ください。");
          this.site.hid = res.data.aid;

          updateOrderAddress(this.site).then((res) => {
            if (res.code != 0) return false;
            this.$message.success("操作成功");
            this.siteDialogVisible = false;
            this.clientOrderList();
          });
        });
      });
    },
    // 修改配送方式
    amendPei(item) {
      let datas = {
        ordno: item.ordno,
      };

      this.$confirm(
        "注意！！倉庫止めに変更された場合は倉庫到着まで直送へ変更手続きができません。商品到着後、倉庫より配送依頼の提出になります。変更いたしますか？?",
        "提示",
        {
          confirmButtonText: "確定",
          cancelButtonText: "キャンセル",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          forbid_pordno(datas).then((res) => {
            if (res.code != 0) return false;
            this.$message.success("操作成功");
            this.clientOrderList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "キャンセル",
          });
        });
    },
    // 验证地址不能为空
    verifySiteNull(data, i) {
      if (data == undefined || data == "") {
        if (i == 0) {
          this.$message.error("氏名をご記入ください。");
        } else if (i == 1) {
          this.$message.error("郵便をご記入ください。");
        } else if (i == 2) {
          this.$message.error("住所をご記入ください。");
        } else if (i == 3) {
          this.$message.error("携帯番号をご記入ください。");
        }
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 50px;
  padding: 30px 40px;

  .header {
    height: 44px;
    line-height: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 20px;

    ul {
      float: left;

      li {
        height: 40px;
        float: left;
        margin: 0 10px;
        color: #333;

        a {
          display: inline-block;
          height: 40px;
          color: #333;

          strong {
            color: #b7040b;
          }
        }

        .choose {
          color: #b7040b;
          //   border-bottom: 2px solid #f3c622;
        }

        span {
          margin-left: 10px;
        }
      }
    }

    .history {
      margin-left: 20px;
      color: #999;
      text-decoration: underline;
      font-size: 16px;
      font-weight: 500;

      &:hover {
        color: #666;
      }
    }

    .search {
      margin: 0 10px 0 0;

      input {
        padding-left: 5px;
        width: 175px;
        height: 30px;
        border-radius: 5px;
        border: 1px solid #dcdfe6;
        margin-left: 20px;
      }

      a {
        margin-left: 20px;
        font-size: 14px;
        display: inline-block;
        width: 80px;
        height: 32px;
        background: #f3c622;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        color: #222;
        background-color: #f3c622;
      }
    }

    .fanghui {
      margin-right: 30px;
      cursor: pointer;
    }
  }

  #search {
    height: 44px;
    margin-bottom: 20px;

    .search {
      input {
        padding-left: 5px;

        width: 205px;
        height: 30px;
        border-radius: 5px;
        border: 1px solid #dcdfe6;

        &::placeholder {
          color: #cecece;
        }
      }
    }

    a {
      margin-left: 20px;
      font-size: 14px;
      display: inline-block;
      width: 80px;
      height: 32px;
      background: #f3c622;
      border-radius: 2px;
      text-align: center;
      line-height: 32px;
      color: #222;
      background-color: #f3c622;
    }
  }

  .body {
    font-weight: 500;
    margin-bottom: 30px;
    border-radius: 4px;
    border: 1px solid #e9e9e9;

    a {
      color: #f3c622;
    }

    ol,
    ul {
      display: flex;

      li {
        flex: 1;
      }

      .border {
        border-right: 1px solid #e9e9e9;
      }

      .flex05 {
        flex: 0.5;
      }
    }

    ol {
      text-align: center;

      height: 52px;
      line-height: 52px;
      background: #f5f5f5;
      color: #222;
      font-weight: 600;
    }

    .order {
      display: flex;
      border-top: 0;

      font-size: 14px;

      .flex15 {
        flex: 1.4;
        padding: 20px 30px;

        background-color: #fefaea;
      }

      .flex05 {
        flex: 0.5;
        border-bottom: 1px solid #e9e9e9;
        border-left: 1px solid #e9e9e9;
        padding-left: 1px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      input {
        width: 322px;
        height: 30px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #dcdfe6;
      }

      button {
        background: #f3c622;
        color: #fff;
        padding: 0;
        border-radius: 3px;
        font-size: 14px;
        width: 80px;
        height: 32px;
        background: #f3c622;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        color: #222;
      }

      a {
        color: #b7040b;
      }
    }

    .guanli {
      margin-top: 20px;
      height: 32px;
      line-height: 32px;

      span {
        display: inline-block;
        width: 222px;
      }

      input {
        margin: 0;
        width: 200px;
      }
    }

    .details {
      display: flex;
    }

    .ul {
      flex: 3;
    }

    ul {
      border-top: 1px solid #cecece;
      font-size: 14px;
      margin-right: -1px;

      &:nth-child(1) {
        border: 0;
      }

      .content {
        padding: 20px 30px;

        display: flex;

        .img {
          margin-right: 20px;

          img {
            width: 100px;
            height: 120px;
          }
        }

        .text {
          line-height: 32px;
          position: relative;

          div {
            margin-bottom: 10px;
          }

          .row {
            display: flex;

            .shuXing {
              flex: 1.5;
            }

            .item {
              flex: 1;

              span {
                display: inline-block;
                width: 50px;
              }
            }
          }

          .url {
            line-height: 20px;

            a {
              color: #b7040b;
            }
          }

          .fr {
            color: #666666;
            width: 100px;
            text-align: right;
            margin-right: 20px;
          }

          span {
            display: inline-block;
            width: 50px;
          }

          input {
            width: 160px;
            height: 32px;
            background: #f9f9f9;
            border-radius: 2px;
            padding: 0 5px;
            border: 1px solid #dcdfe6;

            :nth-last-child(1) {
              width: 300px;
            }
          }

          .bei {
            input {
              width: 324px;
            }

            button {
              width: 80px;
              height: 30px;
              border-radius: 5px;
              background: #f3c622;
              color: #fff;
            }
          }

          .huan {
            width: 20px;
            height: 20px;
            border: 2px solid red;
            line-height: 20px;
            position: absolute;
            bottom: 5px;
            right: 20px;
            font-size: 14px;
            font-weight: 700;
            color: red;
            border-radius: 50%;
            text-align: center;
          }
        }
      }

      .time {
        padding: 20px 10px;

        .timeItem {
          margin-bottom: 20px;

          span {
            display: inline-block;
            width: 100px;
            text-align: center;

            margin-right: 10px;
          }
        }
      }
    }

    .sizhi {
      flex: 1;

      display: flex;
      justify-content: center;
      align-items: center;

      p {
        margin-bottom: 20px;

        &:nth-last-child(1) {
          margin: 0;
        }
      }
    }

    .deliver {
      margin-top: 10px;
      border: 1px solid #ccc;
      padding: 10px 20px;

      .deliverOrder {
        display: flex;
      }

      .danhao {
        flex: 1.5;
      }

      .weight {
        flex: 1;
        display: flex;

        span {
          flex: 1;
          text-align: center;
        }
      }

      .gujiOrder {
        flex: 1.5;
        text-indent: 2em;

        span {
          margin-left: 30px;
        }
      }
    }
  }
}

.fenye {
  width: 500px;
  margin: 30px auto;
  text-align: center;
}

.site {
  margin-left: 50px;

  display: flex;
  background: #fff;

  .importer {
    flex: 1;

    /deep/ .el-select {
      width: 242px;
      margin-top: 6px;
      font-size: 12px;

      .el-input__inner {
        border-radius: 0;
      }
    }

    .importer-box {
      border: 1px solid #cecece;
      padding: 15px;
      width: 210px;
      border-top: 0;

      ul {
        li {
          height: 30px;
          font-size: 12px;
          line-height: 30px;

          input {
            height: 20px;
            width: 140px;
            border: 1px solid #cecece;
          }
        }
      }
    }
  }

  .margin-right {
    margin-right: 60px;
  }
}

button {
  background: #f3c622;
  color: #fff;
  padding: 0;
  border-radius: 3px;
  font-size: 14px;
  width: 80px;
  height: 32px;
  background: #f3c622;
  border-radius: 2px;
  text-align: center;
  line-height: 32px;
  color: #222;
  cursor: pointer;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #f3c622;
  color: #222;
}

.pc-form {
  display: inline-block;

  .submit {
    font-size: 16px;
    background: transparent;
    border: 0;
    color: #f3c622;
    cursor: pointer;
  }
}
</style>
